import {
  ApiNewDokumentPowiazanyDalDto,
  EgibObject,
  LawPerson,
} from '@gk/gk-modules';
import {
  DocumentationFormType,
  InvestorRequest,
  InvestorRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';

export interface APNEDNewRequestDto extends InvestorRequestDto {
  OkreslenieRobotBudowlanych: string;
  PodstawaRobotBudowlanych: string;
  UzasadnienieWniosku: string;
}

export class APNEDNewRequest extends InvestorRequest {
  constructor(
    lawPerson: LawPerson,
    contactData: LawPerson,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    public constructionWorkDefinition: string,
    public constructionWorkBasis: string,
    public requestJustification: string,
    electronicCorrespondenceStatement: boolean,
    proxyDetails: InvestorDetails,
    proxyDetailsCheckbox: boolean,
  ) {
    super(
      lawPerson,
      contactData,
      documentationForm,
      shippingForm,
      electronicCorrespondenceStatement,
      proxyDetails,
      proxyDetailsCheckbox,
    );
  }

  static fromAppToApi(
    data: APNEDNewRequest,
    parcels: EgibObject[],
    buildings: EgibObject[],
    premises: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): APNEDNewRequestDto {
    return {
      ...InvestorRequest.mapCommonFields({
        data,
        parcels,
        buildings,
        premises,
        files,
      }),
      OkreslenieRobotBudowlanych: data.constructionWorkDefinition,
      PodstawaRobotBudowlanych: data.constructionWorkBasis,
      UzasadnienieWniosku: data.requestJustification,
    };
  }
}
